import { AppRoute } from '@app/core/routing/AppRoute';
import { Switch } from 'react-router-dom';
import { UploadPage } from '../screens/upload/UploadPage';

export function AssetsRoutes() {
  return (
    <Switch>
      <AppRoute path={`/assets/upload`} component={UploadPage} />
    </Switch>
  );
}
